import React, { useState, useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { createCanvas } from 'canvas';

const Form_f = () => {
    const [formData, setFormData] = useState({
        sr_no: '',
        book_no: '',
        news_no: '',
        no: '',
        thana: '',
        district: '',
        date: '',
        time: '',
        r_date: '',
        r_time: '',
        name_news: '',
        crime: '',
        place: '',
        criminal_loc: '',
        operation: '',
        d_date: '',
        d_time: '',
        remarks: '',
        phone_no: '',
        token_id: 'E FIR - ',
        status_f: '',
        status_c: '',
        under_inquiry: '',
        paid_quiry: '',
        weapon: '',
        witness: '',
        crime_news: '',
        name: '',
        n_field: ''
    });

    const [message, setMessage] = useState(null);
    const [barcodeImage, setBarcodeImage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const generateBarcode = (token_Id) => {
        const canvas = createCanvas();
        JsBarcode(canvas, token_Id, { format: "CODE128" });
        return canvas.toDataURL("image/png");
    };

    useEffect(() => {
        if (formData.token_id) {
            const barcodeImage = generateBarcode(formData.token_id);
            setBarcodeImage(barcodeImage);
        } else {
            setBarcodeImage(null);
        }
    }, [formData.token_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.token_id) {
            setMessage("Please fill in the required fields");
            return;
        }

        try {
            const response = await fetch('https://chaman.gob.pk/eac_backend/form.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'add',
                    ...formData,
                    barcode: barcodeImage
                })
            });

            const result = await response.json();
            if (result.status === "success") {
                setMessage(result.message);
                setFormData({
                    sr_no: '',
                    book_no: '',
                    news_no: '',
                    no: '',
                    thana: '',
                    district: '',
                    date: '',
                    time: '',
                    r_date: '',
                    r_time: '',
                    name_news: '',
                    crime: '',
                    place: '',
                    criminal_loc: '',
                    operation: '',
                    d_date: '',
                    d_time: '',
                    remarks: '',
                    phone_no: '',
                    token_id: '',
                    status_f: '',
                    status_c: '',
                    under_inquiry: '',
                    paid_quiry: '',
                    weapon: '',
                    witness: '',
                    crime_news: '',
                    name: '',
                    n_field: '',
                });
                setBarcodeImage(null);
                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 2000);
            } else {
                setMessage("Error: " + result.message);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setMessage("An error occurred while submitting the form. Please try again.");
        }
    };

    return (
        <div className="lc-form-container" style={{ direction: 'rtl' }}>
            <form className="lc-formfir" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                    <div className='lc-form-group'>
                        <label className='lc-label'>ٹوکن آئی ڈی:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="token_id" value={formData.token_id} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>سیریل نمبر:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="sr_no" value={formData.sr_no} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>بک نمبر:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="book_no" value={formData.book_no} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>نمبر:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="no" value={formData.no} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>تھانہ:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="thana" value={formData.thana} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>ضلع:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="district" value={formData.district} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>تاریخ:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="date" name="date" value={formData.date} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>وقت:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="time" name="time" value={formData.time} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>تاریخ رپورٹ:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="date" name="r_date" value={formData.r_date} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>وقت رپورٹ:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="time" name="r_time" value={formData.r_time} onChange={handleChange} />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                    <div className='lc-form-group'>
                        <label className='lc-label'>نام و سکونت ملزم:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="criminal_loc" value={formData.criminal_loc} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>کاورائی متعلقہ:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="operation" value={formData.operation} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>تھانہ سے رانگی تاریخ:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input lc-date-input'
                                type="date"
                                name="d_date"
                                value={formData.d_date}
                                onChange={handleChange}
                            />
                        </div>
                    </div>


                    <div className='lc-form-group'>
                        <label className='lc-label'>تھانہ سے راونگی وقت:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="d_time" value={formData.d_time} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>اطلاع:</label>
                        <div className="lc-input-container">
                            <textarea
                                className='lc-input lc-textarea'
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                                // placeholder="اپنی اطلاع درج کریں..."
                                dir="rtl"
                            ></textarea>
                        </div>
                    </div>


                    <div className='lc-form-group'>
                        <label className='lc-label'>فون نمبر:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="phone_no" value={formData.phone_no} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'> نام و اطلاع دہندہ::</label>
                        <div className="lc-input-container">
                            <textarea
                                className='lc-input lc-textarea'
                                name="name_news"
                                value={formData.remarks}
                                onChange={handleChange}
                                // placeholder="نام و اطلاع دہندہ درج كریں..."
                                dir="rtl"
                            ></textarea>
                        </div>
                    </div>
                    {/* <div className="w-full mb-4">
                        <label className="block text-right text-[#2c3e50] font-semibold mb-2">
                            نام و اطلاع دہندہ:
                        </label>
                        <div className="w-full">
                            <textarea
                                name="name_news"
                                value={formData.name_news}
                                onChange={handleChange}
                                rows="4"
                                className="w-full min-h-[100px] p-3 rounded-lg border border-gray-300 focus:outline-none focus:border-[#399918] transition-all duration-200 resize-y text-[#2c3e50] bg-[#F5F7F8] placeholder-gray-500 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200"
                                placeholder="نام و اطلاع دہندہ درج کریں..."
                                dir="rtl"
                            ></textarea>
                        </div>
                    </div> */}


                    <div className='lc-form-group'>
                        <label className='lc-label'>کیفیت جرم:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="crime" value={formData.crime} onChange={handleChange} />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>جائے وقوعہ:</label>
                        <div className="lc-input-container">
                            <input className='lc-input' type="text" name="place" value={formData.place} onChange={handleChange} />
                        </div>
                    </div>
                </div>

            </form>
            <button
                type="submit"
                className="lc-submit-btn"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px"
                }}
            >
                {/* <i className="fas fa-save"></i> */}
                <span>Save</span>
            </button>
            {/* {barcodeImage && (
                <div className="lc-barcode-container">
                    <img className="lc-barcode" src={barcodeImage} alt="Barcode" />
                </div>
            )} */}

            {showPopup && (
                <div className="lc-popup">
                    Data Saved Successfully !
                </div>
            )}
        </div>
    );
};

export default Form_f;